import { MenuDrinkBuilder } from "./menu.drink.builder";
import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { DrinkSchedule } from "./schedule/drink.schedule.model";
import { MenuCategory } from "../category/menu.category.model";
import { DrinkPosition } from "./position/drink.position.model";
import { DrinkPositionBuilder } from "./position/drink.position.builder";

export class MenuDrink {
  public readonly reference: DocumentReference;
  public readonly id: string;
  public readonly isActive: boolean;
  public readonly categories: DrinkPosition[];
  public readonly name: string;
  public readonly description: string;
  public readonly image: string;
  public readonly schedule: DrinkSchedule;
  public readonly isEmergency: boolean;
  public readonly isSponsor: boolean;
  public readonly sponsorText: string;

  constructor(builder: MenuDrinkBuilder) {
    this.reference = builder.reference;
    this.name = builder.name;
    this.id = builder.id;
  
    this.isSponsor = builder.isSponsor;
    this.sponsorText = builder.sponsorText;
    this.isActive = builder.isActive;
    this.description = builder.description;
    this.categories = builder.categories;
    this.image = builder.image;
    this.isEmergency = builder.isEmergency;
    this.schedule = new DrinkSchedule(builder.schedule);
  }

  public get hasCategories(): boolean {
    return this.categories.length > 0;
  }

  public isInCategory(category: MenuCategory) {
    return this.categories.some(pos => pos.categoryId == category.id);
  }
  public getCategoriesString(categories: MenuCategory[]): string {
    let x = "";
    categories.forEach(category =>
      this.isInCategory(category) ? (x += category.name + ", ") : (x += "")
    );
    return x.substring(0, x.length - 2);
  }
  public getCategoryPosition(category: MenuCategory) {
    for (let i = 0; i < this.categories.length; i++) {
      if (this.categories[i].categoryId == category.id)
        return this.categories[i].position;
    }

    return -1;
  }

  public get isActiveMonday(): boolean {
    return this.schedule.isActiveMonday;
  }

  public get isActiveTuesday(): boolean {
    return this.schedule.isActiveTuesday;
  }

  public get isActiveWednesday(): boolean {
    return this.schedule.isActiveWednesday;
  }

  public get isActiveThursday(): boolean {
    return this.schedule.isActiveThursday;
  }

  public get isActiveFriday(): boolean {
    return this.schedule.isActiveFriday;
  }

  public get isActiveSaturday(): boolean {
    return this.schedule.isActiveSaturday;
  }

  public get isActiveSunday(): boolean {
    return this.schedule.isActiveSunday;
  }

  public get priceOnMonday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnMonday;
  }

  public get priceOnTuesday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnTuesday;
  }

  public get priceOnWednesday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnWednesday;
  }
  public get priceOnThursday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnThursday;
  }
  public get priceOnFriday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnFriday;
  }
  public get priceOnSaturday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnSaturday;
  }
  public get priceOnSunday(): number {
    return this.schedule.isDailyPrice
      ? this.schedule.price
      : this.schedule.priceOnSunday;
  }
}
